import { gql } from '@apollo/client'

export default gql`
  fragment LibraryPostVideoCardComponent on LibraryPostVideo {
    slug
    type
    title
    duration
    difficultyLevel
    image {
      url
      blurhash
    }
    description
  }
`
